import React from 'react'
import {makeStyles} from '@material-ui/core/styles'
import {Box, Button, TextField, Typography} from '@material-ui/core'
import {connect} from 'react-redux'
import {dataActions} from '../../../../../actions'
import useForm from '../../../../../components/useForm'

const useStyles = makeStyles(theme => ({
    titleBox: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    boundaryBox: {
        margin: '15px 0',
    },
    submitButton: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        margin: theme.spacing(1, 0),
        boxShadow: 'none',
        borderRadius: theme.shape.borderRadius,
        height: '2.625rem',
        textTransform: 'uppercase',
        width: '100%',
        '&:hover': {
            boxShadow: 'none',
            backgroundColor: '#00652A',
        },
    },
    archiveButton: {
        margin: theme.spacing(1, 0),
        boxShadow: 'none',
        borderRadius: theme.shape.borderRadius,
        border: '1px solid #098447',
        color: theme.palette.primary.main,
        height: '2.625rem',
        textTransform: 'uppercase',
        width: '100%',
    },
}))

const EditCategory = props => {
    const classes = useStyles()
    const {
        token,
        handleCloseDialog,
        handleToggleStatus,
        currenteventcategory,
        eventcategorylist,
        updateEventcategory,
        deleteEventcategory,
        clearEventCategory,
    } = props

    const {
        name: catName,
        descr: catComments,
        updatedTime: catLastSaved,
    } = currenteventcategory

    let payload = {}

    const handleArchive = async (token, values) => {
        let newStatus = currenteventcategory.status === 'I' ? 'A' : 'I'
        let archivecategory = {
            ...currenteventcategory,
            status: newStatus,
        }
        payload = {values, currenteventcategory: archivecategory}

        updateEventcategory(token, payload)
        handleToggleStatus(newStatus)
    }

    const handleDelete = async token => {
        payload = {currenteventcategory}
        clearEventCategory({})
        deleteEventcategory(token, payload)
        handleCloseDialog()
    }

    const initFormValues = {
        categoryname: catName,
        categorycomments: catComments,
    }

    const {values, isChanged, handleChange, handleSubmit} = useForm(
        submiteditcategory,
        initFormValues
    )

    payload = {
        values,
        currenteventcategory,
    }

    function submiteditcategory() {
        updateEventcategory(token, payload)
        handleToggleStatus('A')
        handleCloseDialog()
    }

    const nameduplicate = eventcategorylist.filter(
        eventcat =>
            eventcat.name === values.categoryname &&
            eventcat.id !== currenteventcategory.id
    )

    const nameerror = nameduplicate.length > 0 ? true : false

    return (
        <>
            <form onSubmit={handleSubmit}>
                <Box className={classes.boundaryBox}>
                    <TextField
                        id="categoryname"
                        name="categoryname"
                        label="Category Title"
                        fullWidth
                        autoFocus
                        autoComplete="off"
                        margin="normal"
                        variant="outlined"
                        required
                        error={nameerror}
                        helperText={
                            nameerror &&
                            'Duplicate Category Title found in ' +
                                (nameduplicate[0].status === 'A'
                                    ? 'Active'
                                    : 'Archive') +
                                ' event categories'
                        }
                        value={values.categoryname}
                        onChange={handleChange}
                    />

                    <TextField
                        id="categorycomments"
                        name="categorycomments"
                        label="Comments"
                        fullWidth
                        autoComplete="off"
                        margin="normal"
                        variant="outlined"
                        multiline
                        rows={3}
                        value={values.categorycomments}
                        onChange={handleChange}
                    />
                </Box>
                <Box className={classes.boundaryBox}>
                    <Button
                        type="submit"
                        variant="contained"
                        size="medium"
                        disabled={nameerror || !isChanged}
                        className={classes.submitButton}
                    >
                        Update Category
                    </Button>
                    <Button
                        type="button"
                        variant="outlined"
                        size="medium"
                        disabled={nameerror}
                        className={classes.archiveButton}
                        onClick={() => handleArchive(token, values)}
                    >
                        {currenteventcategory.status === 'I'
                            ? 'Re-Activate'
                            : 'Archive'}
                    </Button>
                    <Button
                        type="button"
                        variant="outlined"
                        size="medium"
                        disabled={nameerror}
                        className={classes.archiveButton}
                        onClick={() => handleDelete(token, values)}
                    >
                        Delete Category
                    </Button>

                    <Typography
                        variant="body2"
                        style={{fontWeight: 700, opacity: 0.7}}
                    >
                        LAST SAVED : &thinsp;
                        {catLastSaved
                            ? new Date(catLastSaved).toLocaleString() +
                              ' by ' +
                              currenteventcategory.updatedBy
                            : 'NEVER'}
                    </Typography>
                </Box>
            </form>
        </>
    )
}

function mapStateToProps(state) {
    return {
        fetchingEventCategory: state.eventcategorydata.fetchingEventCategory,
        token: state.authentication.token,
        currenteventcategory: state.seteventcategorydata.eventcategory,
        eventcategorylist: state.eventcategorydata.eventCategorylist,
    }
}

const mapDispatchToProps = {
    updateEventcategory: (token, payload) =>
        dataActions.eventcategoryUpdateRequest(token, payload),
    deleteEventcategory: (token, payload) =>
        dataActions.eventcategoryDeleteRequest(token, payload),
    clearEventCategory: payload => dataActions.eventcategorySetClear(payload),
}

export default connect(mapStateToProps, mapDispatchToProps)(EditCategory)
